/**
 * Group list filters: standard columns + custom_properties (same operator sets as user properties).
 */

import {
  getOperatorsForUserType,
  getNumericCountOperators,
  getDefaultOperator as getUserDefaultOperator,
} from 'features/activity/config/userFilterProperties';

/** Built-in group row fields (not in custom_properties JSON) */
export const GROUP_STANDARD_PROPERTIES = [
  { name: 'group_id', label: 'Group ID', type: 'string', source: 'group', isStandard: true },
  { name: 'member_count', label: 'Members', type: 'number', source: 'group', isStandard: true },
  { name: 'last_updated_at', label: 'Last Updated', type: 'datetime', source: 'group', isStandard: true },
];

export function getOperatorsForGroupType(type) {
  return getOperatorsForUserType(type);
}

export function getGroupEventCountOperators() {
  return getNumericCountOperators();
}

export function getDefaultGroupOperator(type) {
  return getUserDefaultOperator(type);
}
